/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_ShareInputs */

const en_btn_share = /** @type {(inputs: Btn_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share`)
};

const ar_btn_share = /** @type {(inputs: Btn_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مشاركة`)
};

const de_btn_share = /** @type {(inputs: Btn_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilen`)
};

const es_btn_share = /** @type {(inputs: Btn_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartir`)
};

const fr_btn_share = /** @type {(inputs: Btn_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partager`)
};

const it_btn_share = /** @type {(inputs: Btn_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condividi`)
};

const ja_btn_share = /** @type {(inputs: Btn_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`共有`)
};

const ko_btn_share = /** @type {(inputs: Btn_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`공유`)
};

const pt_br_btn_share = /** @type {(inputs: Btn_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartilhar`)
};

const ru_btn_share = /** @type {(inputs: Btn_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поделиться`)
};

const th_btn_share = /** @type {(inputs: Btn_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แชร์`)
};

const tr_btn_share = /** @type {(inputs: Btn_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paylaş`)
};

const zh_cn_btn_share = /** @type {(inputs: Btn_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分享`)
};

const zh_tw_btn_share = /** @type {(inputs: Btn_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分享`)
};

/**
* | output |
* | --- |
* | "Share" |
*
* @param {Btn_ShareInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_share = /** @type {((inputs?: Btn_ShareInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_ShareInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_share(inputs)
	if (locale === "ar") return ar_btn_share(inputs)
	if (locale === "de") return de_btn_share(inputs)
	if (locale === "es") return es_btn_share(inputs)
	if (locale === "fr") return fr_btn_share(inputs)
	if (locale === "it") return it_btn_share(inputs)
	if (locale === "ja") return ja_btn_share(inputs)
	if (locale === "ko") return ko_btn_share(inputs)
	if (locale === "pt_br") return pt_br_btn_share(inputs)
	if (locale === "ru") return ru_btn_share(inputs)
	if (locale === "th") return th_btn_share(inputs)
	if (locale === "tr") return tr_btn_share(inputs)
	if (locale === "zh_cn") return zh_cn_btn_share(inputs)
	return zh_tw_btn_share(inputs)
});